/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"
import { flexColumnCentered } from "frontend/src/utils/flexUtils"
import { SectionGrid, Flex } from "frontend/src/components/Layout"
function Promises({ title, subTitle, icons }) {
  return (
    <SectionGrid sx={{ bg: "gray_200", py: 13 }}>
      <SectionGrid.narrow
        sx={{
          textAlign: ["left", "center"],
          px: [5, 5, 0],
          color: "almostBlack",
        }}
      >
        <h2
          sx={{
            fontFamily: "heading",
            fontSize: ["28px", "28px", "38px"],
            lineHeight: ["30px", "30px", "44px"],
            fontWeight: ["medium", "medium", "regular"],
            letterSpacing: "-1.24px",
            mb: 5,
          }}
        >
          {title}
        </h2>
        <p
          sx={{
            fontFamily: "body",
            fontSize: "22px",
            fontWeight: "light",
            letterSpacing: "0.24px",
            lineHeight: "28px",
            mt: 4,
            mb: 11,
          }}
        >
          {subTitle}
        </p>
        <Flex direction={["column", "row"]} align={["flex-start", "center"]} justify="space-around">
          {icons.map((icon, index) => (
            <article
              key={icon._key}
              sx={{
                ...flexColumnCentered,
                width: ["100%", "auto"],
                maxWidth: ["unset", index === 2 ? "10rem" : "11rem"],
                mb: [5, 0],
              }}
            >
              <figure
                sx={{
                  width: ["3rem", "100%"],
                  mr: [3, 0],
                  ml: [-2, 0],
                  "& img": {
                    maxWidth: ["3rem", "5rem"],
                    transform: ["translateX(-50%)", "translateX(-50%)"],
                  },
                }}
              >
                <Img
                  sx={{ width: "auto", height: [60, 80, 110] }}
                  fluid={getFluidFromAsset(icon, 100)}
                  alt={icon.alt}
                  imgStyle={{ objectFit: "scale-down", left: "50%" }}
                />
              </figure>
              <h3
                sx={{
                  fontSize: [4, 4, "24px"],
                  fontFamily: "heading",
                  fontWeight: "regular",
                  lineHeight: ["26px", "26px", "28px"],
                  letterSpacing: ["0px", "0px", "-0.5px"],
                  mt: [0, 4],
                }}
              >
                {icon.description}
              </h3>
            </article>
          ))}
        </Flex>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { Promises }
